import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ClienteScreen from './ClienteScreen';
import GarcomScreen from './GarcomScreen';
import AdminDashboard from './components/AdminDashboard';
import Dashboard from './Dashboard/Dashboard';
import LoginDashboard from './components/LoginDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import Footer from "./components/Footer";

const RedirectHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("🔍 URL atual:", location.pathname);

    // Se o usuário acessar "/", redireciona para "/cliente"
    if (location.pathname === "/") {
      navigate("/cliente", { replace: true });
    }

    // Detecta se o app está rodando como PWA
    const isPWA = window.matchMedia("(display-mode: standalone)").matches;

    // Se estiver no PWA e a URL for "/" ou "/cliente", redireciona para "/garcom"
    if (isPWA && (location.pathname === "/" || location.pathname === "/cliente")) {
      navigate("/garcom", { replace: true });
    }
  }, [location, navigate]);

  return null;
};

function App() {
  return (
    <Router>
      <RedirectHandler />
      <Routes>
        <Route path="/cliente" element={<ClienteScreen />} />
        <Route path="/garcom" element={<GarcomScreen />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/login-dashboard" element={<LoginDashboard />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
  <div className="main-content">
    {/* Aqui fica o conteúdo principal da aplicação */}
  </div>
  
</Router>

  );
}

export default App;
